// Sahifadan sahifaga FILTR BILAN o'tish havolalari.
//
// ⚠️ NEGA BITTA MODUL. Havola ikki narsani bilishi kerak: manzil va
// filtr parametrining IMLOSI. Imlo `useTableUrlState` ning ichki
// qoidasi (`f.<ustun>`) va u hech qayerda e'lon qilinmagan. Har
// chaqiruv joyi uni o'zi yozganda bittasi adashardi va natija JIMGINA
// buzilish bo'lardi: sahifa ochiladi, filtr esa qo'llanmaydi — operator
// TO'LIQ ro'yxatni "shu agentniki" deb o'qiydi.
//
// ⚠️ MARSHRUT HOLATI EMAS, MANZIL. `navigate(path, { state })` sahifa
// qayta yuklanganda yo'qoladi va havolani yuborib ham bo'lmaydi.

/**
 * Jadval holati manzilda `f.<ustun>` shaklida yashaydi
 * (`tableState.paramNames`). Havola AYNI imloda yoziladi.
 */
export const FILTER_PREFIX = 'f.'

export const GRANTS_PATH = '/grants'
export const TRANSACTIONS_PATH = '/transactions'

function withFilters(path: string, filters: Readonly<Record<string, string>>): string {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(filters)) {
    if (value !== '') params.set(`${FILTER_PREFIX}${key}`, value)
  }
  const query = params.toString()
  return query === '' ? path : `${path}?${query}`
}

/**
 * Tranzaksiyalar sahifasi, ega bo'yicha filtrlangan.
 *
 * ⚠️ `ownerType` HAM yuboriladi, faqat `ownerId` emas. Sahifadagi
 * `JournalOwnerBanner` aynan shu juftlik bilan chiziladi va u ro'yxat
 * TORAYTIRILGANINI aytadigan yagona belgi. Turi berilmasa banner
 * chizilmaydi va operator qisqargan ro'yxatni to'liq deb o'qirdi.
 */
export function transactionsHref(ownerType: string, ownerId: string): string {
  return withFilters(TRANSACTIONS_PATH, { ownerType, ownerId })
}

/** Berilgan paketlar sahifasi, ixtiyoriy filtrlar bilan */
export function grantsHref(filters: Readonly<Record<string, string>>): string {
  return withFilters(GRANTS_PATH, filters)
}
